// extracted by mini-css-extract-plugin
module.exports = {"container":"synced-widget-header_container__0negl","title":"synced-widget-header_title__KGvfh","subtitle":"synced-widget-header_subtitle__I1FZ0"};